import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router";
import Svg from "../components/figs/Svg";

export default function Verify() {
  const { msg } = useSelector((s) => s.language);
  const loc = useLocation();
  const searchParams = new URLSearchParams(loc.search);
  const verifyStatus = searchParams.get("status");
  const verifyMsg = searchParams.get("msg");
  useEffect(() => {
    localStorage.clear();
  }, []);
  return (
    <div className="absolute w-full h-full">
      <div className="_main_bg"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center rounded-2xl p-8 shadow-lg bg-[var(--bright)] min-w-[20rem]">
        <Svg iconName="logo" className="h-[2rem] w-fit" />
        <br />
        <h1
          className={`text-xl font-bold mb-4 ${
            verifyStatus === "success"
              ? "text-[var(--primary)]"
              : "text-red-400"
          }`}
        >
          {verifyMsg}
        </h1>
        <Link className="_fill_button_2" to="/">
          {msg.sign_in}
        </Link>
      </div>
    </div>
  );
}
